import { Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { IZippyChangeEvent, IZippyId, parseZippyName, subject, ZippyEventType } from './zippy.abstract';

@Injectable({
    providedIn: 'root'
})
export class ZippyService {
    private openZippyIds = new Set<string>();

    constructor() {
        subject.pipe(takeUntilDestroyed()).subscribe(event => {
            if (event.type === ZippyEventType.change) {
                if ((event as IZippyChangeEvent).visible) {
                    this.openZippyIds.add(this.toStringId(event.id));
                } else {
                    this.openZippyIds.delete(this.toStringId(event.id));
                }
            }
        });
    }

    /**
     * Open zippy
     */
    open(zippyId: string | string[] | IZippyId) {
        subject.next({
            id: this.toZippyId(zippyId),
            type: ZippyEventType.open
        });
    }

    /**
     * Close zippy
     */
    close(zippyId: string | string[] | IZippyId) {
        subject.next({
            id: this.toZippyId(zippyId),
            type: ZippyEventType.close
        });
    }

    closeAll(zippyId: string | string[]) {
        subject.next({
            id: this.toZippyGroup(zippyId),
            type: ZippyEventType.close
        });
    }

    /**
     * Covnert to zippy id
     */
    toZippyId(name: string | (string | number)[] | IZippyId): IZippyId {
        if (typeof name == 'object' && !Array.isArray(name)) {
            return name;
        }
        return parseZippyName(name);
    }

    toStringId(zippyId: string | string[] | IZippyId): string {
        const id = this.toZippyId(zippyId);
        return `${id.group}::${id.name}`;
    }

    toHtmlId(zippyId: string | string[] | IZippyId): string {
        return `zippy-${this.toStringId(zippyId)}`;
    }

    isGroupOpen(zippyId: string | string[] | IZippyId): boolean {
        const id = this.toZippyId(zippyId);
        return Array.from(this.openZippyIds.values()).some(openId => openId.startsWith(id.group + '::'));
    }

    isOpen(_zippyId: string | string[] | IZippyId): boolean {
        const zippyId = this.toStringId(_zippyId);
        return this.openZippyIds.has(zippyId);
    }

    /**
     * Covnert to zippy id
     */
    private toZippyGroup(name: string | (string | number)[]): IZippyId {
        const id = parseZippyName(name);
        if (id.group) {
            id.isGroup = true;
        }
        return id;
    }
}
